export interface RestaurantTimingDataType {
  id: number;
  day: string;
  status: string;
  startTime: string;
  endTime: string;
  createdAt: Date;
  updatedAt: Date;
}

export interface RestaurantTimingRequestType {
  restaurantId: number;
  day: string;
  status: string;
  type: string;
  startTime?: string;
  endTime?: string;
}

export interface RestaurantTimingResponseType {
  data: RestaurantTimingDataType;
  message: string;
  success: boolean;
  error?: string | null;
}

export interface AllRestaurantTimingResponseType {
  data: RestaurantTimingDataType[];
  message: string;
  success: boolean;
  error?: string | null;
}

export enum WeekDays {
  Monday = 'monday',
  Tuesday = 'tuesday',
  Wednesday = 'wednesday',
  Thursday = 'thursday',
  Friday = 'friday',
  Saturday = 'saturday',
  Sunday = 'sunday',
}

export const dayMap: { [key: string]: WeekDays } = {
  Mon: WeekDays.Monday,
  Tue: WeekDays.Tuesday,
  Wed: WeekDays.Wednesday,
  Thu: WeekDays.Thursday,
  Fri: WeekDays.Friday,
  Sat: WeekDays.Saturday,
  Sun: WeekDays.Sunday,
};

export enum RestaurantTimingStatus {
  Open = 'open',
  Closed = 'closed',
}

export enum RestaurantTimingType {
  Restaurant = 'restaurant',
  Delivery = 'delivery',
  DeliverySlot = 'delivery-slot',
  PickupSlot = 'pickup-slot',
  Takeaway = 'take-away',
  Schedule = 'schedule',
}

export enum QRNotificationType {
  Email = 'email',
  SMS = 'sms',
}
export enum OrderTypeGuest {
  Delivery = 'delivery',
  Takeaway = 'take-away',
}

export enum PaymentProviderType {
  Stripe = 'stripe',
  Adyen = 'adyen',
}

export enum WeekdaysWithCapitalLetter {
  Monday = 'Monday',
  Tuesday = 'Tuesday',
  Wednesday = 'Wednesday',
  Thursday = 'Thursday',
  Friday = 'Friday',
  Saturday = 'Saturday',
  Sunday = 'Sunday',
}
